module.exports = __webpack_public_path__ + "img/southland-logo.c0cb603b.jpg";